import React from "react";
import { Box, Button, Container, Flex, Heading, Image, SimpleGrid, Text } from "@chakra-ui/react";
import Header from "../components/header/header";
import DummyImage from "../../assets/img/dummy-img2.jpeg";
import Footer from "../components/footer/footer";
import "./whatIcanUseForIT.scss";

const WhatIsUse = () => {
    return(
        <div className="what-can-i-use">
            <div className="what-can-i-use-header-about-doc">
                <Header />
            </div>

            <Box className="what-hero-spacer">
                <Container maxW="6xl" />
            </Box>

            <Box className="what-section what-steps-section">
                <Container maxW="6xl">
                    <Heading as="h2" className="what-section-title">A Simple, Supportive Process</Heading>
                    <Text className="what-section-sub">Care that meets you where you are, with long-term behavioral health support.</Text>
                    <SimpleGrid
                        columns={{ base: 1, md: 2, lg: 3 }}
                        gap={{ base: "20px", md: "28px", lg: "34px" }}
                        rowGap={{ base: "20px", md: "28px", lg: "34px" }}
                        columnGap={{ base: "20px", md: "28px", lg: "34px" }}
                    >
                        <Box className="what-step-card">
                            <span className="what-step-number">1</span>
                            <Heading as="h3">Sign Up</Heading>
                            <Text>Creating an account takes less than a minute.</Text>
                        </Box>
                        <Box className="what-step-card">
                            <span className="what-step-number">2</span>
                            <Heading as="h3">Start Chatting</Heading>
                            <Text>Tell us about your concerns and we&apos;ll gather more information about your case.</Text>
                        </Box>
                        <Box className="what-step-card">
                            <span className="what-step-number">3</span>
                            <Heading as="h3">Talk to a Doctor</Heading>
                            <Text>Get connected to a licensed doctor who can diagnose and treat your issues, including writing prescriptions.</Text>
                        </Box>
                    </SimpleGrid>
                </Container>
            </Box>

            <Box className="what-section what-booking-section">
                <Container maxW="6xl">
                    <Box className="what-booking-card">
                        <Flex className="what-booking-inner" gap={8} wrap="wrap" align="center">
                            <Box className="what-booking-img">
                                <Image src={DummyImage} alt="Book appointment" />
                            </Box>
                            <Box className="what-booking-text">
                                <Heading as="h3">Book an appointment that&apos;s convenient for you.</Heading>
                                <Text>No matter where you are or how busy your life gets, you can talk to one of our many friendly and knowledgeable doctors online at a time that works with your schedule.</Text>
                                <Button className="what-booking-cta">Book an Appointment</Button>
                            </Box>
                        </Flex>
                    </Box>
                </Container>
            </Box>

            <Footer />
        </div>
    );
};

export default WhatIsUse;
